import { HStack, Text } from "native-base";
import { COLORS } from "../../utils/colors";
import { COMMONFONTWEIGHT } from "../../utils/fonts";
import { hasPermission } from "../../utils/permission";

export const CommonTabs = ({
  tabs = [],
  activeButton = "",
  setActiveButton = () => {},
}) => {
  return (
    <HStack
      w={(hasPermission("PACKAGES_TAB") || hasPermission("QUICK_MEET")) ? 450 : 170}
      justifyContent={"space-between"}
    >
      {tabs.map((tab) => {
        if (tab.show)
          return (
            <Text
              key={tab.key}
              onPress={() => setActiveButton(tab.key)}
              fontSize={18}
              fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
              color={COLORS.TABS_TEXT_COLOR}
              borderBottomWidth={activeButton === tab.key && 3}
              borderBottomColor={
                activeButton === tab.key && COLORS.TABS_ACTIVE_BORDER_COLOR
              }
              w={(hasPermission("PACKAGES_TAB") || hasPermission("QUICK_MEET")) ? 100 : 65}
              textAlign="center"
              pb={0.5}
              marginBottom={"12px"}
              style={{ whiteSpace: 'nowrap' }}
            >
              {tab.title}
            </Text>
          );
      })}
    </HStack>
  );
};
